var creditcards = require('../creditcards/index');

angular.module('component-payments.validate.expire', [])
	.directive('ctPaymentsValidateExpire', paymentsValidateExpireDirective);

function paymentsValidateExpireDirective() {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: postLink
	};

	function postLink(scope, element, attrs, NgModelCtrl) {
		scope.$watch(attrs.ctPaymentsValidateExpire, function (value) {
			if (value && !NgModelCtrl.$touched) {
				NgModelCtrl.$setTouched();
			}

			NgModelCtrl.$setViewValue(angular.copy(value));
		}, true);

		NgModelCtrl.$parsers.push(function(viewValue) {
			var modelValue;

			if (viewValue) {
				modelValue = [
					parseInt(viewValue.year) < 10 ? '0' + viewValue.year : viewValue.year,
					parseInt(viewValue.month) < 10 && viewValue.month.length == 1 ? '0' + viewValue.month : viewValue.month
				].join('');
			}

			return modelValue;
		});

		NgModelCtrl.$validators.invalidExpire = function (modelValue) {
			return true;//TODO: revert after war.

			// var value = modelValue || '',
			// 	year, month;
			//
			// if (value.length < 4)
			// 	return true;
			//
			// year = creditcards.expiration.year.parse(value.substr(0, 2), true);
			// month = creditcards.expiration.month.parse(value.substr(2));
			//
			// return !creditcards.expiration.isPast(month, year);
		};
	}
}

module.exports = 'component-payments.validate.expire';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/validators/expire.js
 ** module id = 99
 ** module chunks = 1
 **/